import { useApplication } from '@/hooks/useApplication';
import { ConfigurationType } from '@/types/metadata/metadata';
import { variableUtil } from '@/util/validation/variable';
import { FC, useEffect, useState } from 'react';
import { ParamProps } from './ParamRenderer';
import ParamVariable from './ParamVariable';

const ParamQueueVariable: FC<ParamProps> = (props) => {
  const { application } = useApplication();

  const initialValue = variableUtil().getValue(props.configuration, props.initialValue);

  const [configuration, setConfiguration] = useState(props.configuration);

  useEffect(() => {
    setConfiguration({
      ...configuration,
      subtype: application.queues?.find((queue) => queue.queue === props.initialValue?.queue)
        ?.datatype as ConfigurationType
    });
  }, [props.configuration]);

  return (
    <ParamVariable
      nodeId={props.nodeId}
      configuration={configuration}
      onChange={props.onChange}
      initialValue={initialValue}
      parentId={props.parentId}
      errors={props.errors}
    />
  );
};
export default ParamQueueVariable;
